import { Effort } from '../models/effort';
import { User } from '../models/user';

function hasRole(user: User | undefined, role: string): boolean {
  return user?.userRoles?.some(assignment => assignment.role?.roleName?.toLowerCase() === role) ?? false;
}

function belongsToEffort(user: User, effort: Effort): boolean {
  return user.groupMemberships?.some(membership => membership.groupId === effort.principalGroupId)
    || effort.effortOwners?.some(owner => owner.userId === user.id) || false;
}

// Mirrors ProjectAuthManager.MayAdd; the chosen effort is checked separately.
export function canAddProjects(user?: User): boolean {
  return hasRole(user, 'admin') || hasRole(user, 'fullaccess');
}

export function canCreateProjectInEffort(user: User | undefined, effort?: Effort): boolean {
  if (!user || !effort || effort.isHR || !canAddProjects(user)) return false;
  // IsAuthorizedAdd applies this restriction even when FullAccess and Admin coexist.
  return hasRole(user, 'fullaccess') ? belongsToEffort(user, effort) : hasRole(user, 'admin');
}

export function canEditEffortProjects(user: User | undefined, effort?: Effort): boolean {
  if (!user || !effort || effort.isHR) return false;
  return hasRole(user, 'admin') || (hasRole(user, 'fullaccess') && belongsToEffort(user, effort));
}
